
import * as React from 'react';
import styled from 'styled-components';
import * as lo from 'lodash/fp';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/modals/detail/dataGrid';
import { taskDetailGridColumns } from '@process-advisor/process-miner/model/tasks/taskDetailGridColumns';

type Row = {};
let columns = []
const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

export const TaskDetailGrid: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);

    React.useEffect(() => {
        apiProvider.setTaskDetailExtract({type: 'detail'})
        apiProvider.setDetailSource({source: 'all'})
        setData(apiProvider.processDetailTaskSummary());
    }, []);

    const rows = data.map((row, id) => ({ id, ...row }));
    if (lo.isEmpty(columns)) {
        columns = taskDetailGridColumns(rows);
    }
    
    return (
        <Wrapper>
            <DataGrid
                rows={rows}
                columns={columns}
                type={'event-detail'}
                height="500px" />
        </Wrapper>
    );
};
